<template>
  <div v-bem>
    <h3 v-if="title">{{ title }}</h3>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Start',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.start {
  padding-bottom: utils.f-rem-calc(20);

  @include utils.bs-media-breakpoint-up(md) {
    padding: utils.f-rem-calc(50);
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 1.2rem;
    line-height: 1.1em;
  }

  > :last-child {
    margin-bottom: 0;
  }

  > * {
    line-height: 1.5em;
  }
}
</style>
